export * from "./advert-search-summary-advert.dto.interface";
